import { Modal, Button } from 'react-bootstrap';

const COMING_SOON_FEATURES = [
  {
    title: 'Email Alerts from RECOVER',
    description: 'Subscribe to get a heads-up when we detect storm-driven outage spikes in your selected FEMA regions, straight to your inbox.',
  },
    {
    title: 'Electric lines',
    description: 'View transmission and distribution electric lines alongside outage forecasts.',
  },
  {
    title: 'Critical Infrastructure Assets',
    description: 'Explore hospitals, emergency services, telecommunications, water, wastewater, fuel, shelters, and transportation assets.',
  },
  {
    title: 'Revamped UI',
    description: 'We are completely revamping the UI for a better viewing and interaction experience on the web. We will work on improving the mobile view too, but a significant mobile overhaul is not expected to land anytime soon.',
  }
];

const FeatureItem = ({ title, description }) => (
  <li className="py-3" style={{ borderBottom: '1px solid var(--border-color)' }}>
    <h6 className="mb-1 fw-semibold" style={{ color: 'var(--text-main)' }}>
      {title}
    </h6>
    <p className="mb-0 small" style={{ color: 'var(--text-muted)' }}>
      {description}
    </p>
  </li>
);

const ComingSoonModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title className="fw-bold">
        <i className="fas fa-rocket text-primary me-2"></i>Coming Soon
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {COMING_SOON_FEATURES.map((feature) => (
          <FeatureItem key={feature.title} title={feature.title} description={feature.description} />
        ))}
      </ul>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>Close</Button>
    </Modal.Footer>
  </Modal>
);

export default ComingSoonModal;
